import { render, staticRenderFns } from "./kirimangratisfrm.vue?vue&type=template&id=cb75f76c"
import script from "./kirimangratisfrm.vue?vue&type=script&lang=js"
export * from "./kirimangratisfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports